var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-bg"},[_c('SettingOption',{attrs:{"titles":_vm.titles},on:{"onClick":_vm.onClickTitle}}),_c('div',{staticClass:"options-content"},[_c(_vm.currentComponent,{tag:"component",staticClass:"contents"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }